import type { Proposal } from '@/services/proposals/types';
import { isCapitalGlobalLegalPersonFromStoredCustomer } from '@/features/quotes/utils/resolve-capital-global-id-type.util';
import { cleanCnpjOrCpf } from '@/shared/utils/document.util';

/** @deprecated use `cleanCnpjOrCpf` (normalizador canônico). Mantido como alias. */
export const normalizeCnpjDocument = cleanCnpjOrCpf;

export function isCapitalGlobalLegalPerson(
  proposal: Proposal | undefined,
  documentNumber: string
): boolean {
  return isCapitalGlobalLegalPersonFromStoredCustomer({
    documentType: proposal?.customer?.documentType,
    documentNumber,
    isOrgParty: proposal?.customer?.isOrgParty,
  });
}
